/* global window, document, fetch, setTimeout, clearTimeout, AbortController */
(() => {
  if (window.mastonerCartFiscal) return;
  let draft;
  let saved;
  let pending;
  let timer;
  let submitting = false;
  let passThrough = false;
  const field = () => document.getElementById("cart-fiscal-id");
  const read = () => {
    const input = field();
    if (input && draft === undefined) saved = draft = input.value;
    return input;
  };
  const restore = () => {
    const input = read();
    if (input && draft !== undefined) input.value = draft;
  };
  const showError = (kind) => {
    const error = document.getElementById("cart-fiscal-save-error");
    if (error) {
      error.textContent =
        kind === "quantity"
          ? "No se pudieron confirmar las cantidades. Recarga el carrito y compruébalas antes de continuar."
          : "No se pudo guardar el NIF/CIF. Inténtalo de nuevo antes de continuar.";
      error.hidden = false;
    }
  };
  const flush = () => {
    clearTimeout(timer);
    read();
    if (pending) return pending;
    pending = (async () => {
      while (draft !== undefined && draft !== saved) {
        const value = draft;
        const controller = new AbortController();
        const timeout = setTimeout(() => {
          controller.abort();
        }, 10000);
        let cart;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
            method: "POST",
            signal: controller.signal,
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: { "NIF/CIF": value } }),
          });
          if (!response.ok) throw new Error("No se pudo guardar el NIF/CIF. Inténtalo de nuevo.");
          cart = await response.json();
        } finally {
          clearTimeout(timeout);
        }
        if ((cart.attributes?.["NIF/CIF"] || "") !== value) {
          throw new Error("No se pudo confirmar el NIF/CIF. Inténtalo de nuevo.");
        }
        saved = value;
      }
      const error = document.getElementById("cart-fiscal-save-error");
      if (error) error.hidden = true;
    })().finally(() => {
      pending = undefined;
    });
    return pending;
  };
  window.mastonerCartFiscal = { flush, restore };
  read();
  document.addEventListener("input", (event) => {
    if (event.target.id !== "cart-fiscal-id") return;
    read();
    draft = event.target.value;
    clearTimeout(timer);
    timer = setTimeout(() => {
      flush().catch(showError);
    }, 250);
  });
  document.addEventListener("change", (event) => {
    if (event.target.id !== "cart-fiscal-id") return;
    read();
    draft = event.target.value;
    flush().catch(showError);
  });
  document.addEventListener("submit", async (event) => {
    if (event.target.id !== "cart" || !field()) return;
    if (passThrough) {
      passThrough = false;
      return;
    }
    event.preventDefault();
    if (submitting) return;
    submitting = true;
    const form = event.target;
    const submitter = event.submitter;
    let checkingQuantities = true;
    try {
      draft = field().value;
      await form.querySelector("cart-items")?.flushQuantityChanges();
      checkingQuantities = false;
      await flush();
      restore();
      // Leave the native submit event before requesting another submission.
      await new Promise((resolve) => setTimeout(resolve, 0));
      passThrough = true;
      form.requestSubmit(
        submitter?.isConnected ? submitter : form.querySelector('[name="checkout"]'),
      );
    } catch {
      showError(checkingQuantities ? "quantity" : "fiscal");
      field()?.focus();
    } finally {
      submitting = false;
      passThrough = false;
    }
  });
})();
